import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '../pages/Dashboard';

import BookingWrapper from '../pages/booking/BookingWrapper';
import BookingInfo from '../pages/booking/info/BookingInfo';
import SkiWrapper from '../pages/booking/ski/SkiWrapper';
import SkiRental from '../pages/booking/ski/rental/SkiRental';
import SkiRentalOverview from '../pages/booking/ski/rental/SkiRentalOverview';
import SkiRentalAvailableProducts from '../pages/booking/ski/rental/SkiRentalAvailableProducts';
import SkiRentalPickupPlaces from '../pages/booking/ski/rental/SkiRentalPickupPlaces';
import SkiPass from '../pages/booking/ski/pass/SkiPass';
import SkiPassOverview from '../pages/booking/ski/pass/SkiPassOverview';
import SkiPassAvailableProducts from '../pages/booking/ski/pass/SkiPassAvailableProducts';
import SkiSchool from '../pages/booking/ski/school/SkiSchool';
import SkiSchoolOverview from '../pages/booking/ski/school/SkiSchoolOverview';
import SkiSchoolAvailableProducts from '../pages/booking/ski/school/SkiSchoolAvailableProducts';
import ReminderWrapper from '../pages/reminders/ReminderWrapper';
import ReminderTemplates from '../pages/reminders/ReminderTemplates';
import ReminderRules from '../pages/reminders/ReminderRules';
import ReminderLists from '../pages/reminders/ReminderLists';
import ReminderListsOverdue from '../pages/reminders/ReminderListsOverdue';
import ReminderListsLastReminder from '../pages/reminders/ReminderListsLastReminder';
import Affiliates from '../pages/affiliates/affiliates';

import PageNotFound from '../pages/error-pages/PageNotFound';
import { session } from './middleware';
import ReminderListsArchived from '../pages/reminders/ReminderListsArchived';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Dashboard,
    },
    {
      path: '/reminders',
      name: 'Reminders',
      component: ReminderWrapper,
      redirect: { name: 'ReminderTemplates' },
      children: [
        {
          path: 'templates',
          name: 'ReminderTemplates',
          href: `${process.env.TWENTY_FRONT_PAGE}/ui/booking/communication/payment-reminders`,
          beforeEnter() {
            window.location.href = `${process.env.TWENTY_FRONT_PAGE}/ui/booking/communication/payment-reminders`
          },
        },
        {
          path: 'rules',
          name: 'ReminderRules',
          component: ReminderRules,
          meta: {
            title: 'Reminders - Rules',
          },
        },
        {
          path: 'lists',
          name: 'ReminderLists',
          component: ReminderLists,
          children: [
            {
              path: 'overdue',
              name: 'ReminderListsOverdue',
              component: ReminderListsOverdue,
              meta: {
                title: 'Reminders - Overdue',
              },
            },
            {
              path: 'last-reminder',
              name: 'ReminderListsLastReminder',
              component: ReminderListsLastReminder,
              meta: {
                title: 'Reminders - Last Reminder',
              },
            },
            {
              path: 'archived',
              name: 'ReminderListsArchived',
              component: ReminderListsArchived,
              meta: {
                title: 'Reminders - Archived',
              },
            },
          ],
        },
      ],
    },
    {
      path: '/booking/:bookingId',
      name: 'BookingWrapper',
      component: BookingWrapper,
      props: true,
      redirect: { name: 'BookingInfo' },
      children: [
        {
          path: 'info',
          name: 'BookingInfo',
          component: BookingInfo,
          meta: {
            title: 'Booking info',
          },
        },
        {
          path: 'ski',
          name: 'SkiWrapper',
          component: SkiWrapper,
          redirect: { name: 'SkiRental' },
          children: [
            {
              path: 'rental',
              name: 'SkiRental',
              component: SkiRental,
              props: true,
              redirect: { name: 'SkiRentalOverview' },
              meta: {
                title: 'Ski rental',
              },
              children: [
                {
                  path: 'overview',
                  name: 'SkiRentalOverview',
                  component: SkiRentalOverview,
                  meta: {
                    title: 'Ski rental: Overview',
                  },
                },
                {
                  path: 'available-products',
                  name: 'SkiRentalAvailableProducts',
                  component: SkiRentalAvailableProducts,
                  meta: {
                    title: 'Ski rental: Available products',
                  },
                },
                {
                  path: 'pickup-places',
                  name: 'SkiRentalPickupPlaces',
                  component: SkiRentalPickupPlaces,
                  props: {
                    skiRental: true,
                  },
                  meta: {
                    title: 'Ski rental: Pickup places',
                  },
                },
              ],
            },
            {
              path: 'pass',
              name: 'SkiPass',
              component: SkiPass,
              props: true,
              redirect: { name: 'SkiPassOverview' },
              meta: {
                title: 'Ski pass',
              },
              children: [
                {
                  path: 'overview',
                  name: 'SkiPassOverview',
                  component: SkiPassOverview,
                  meta: {
                    title: 'Ski pass: Overview',
                  },
                },
                {
                  path: 'available-products',
                  name: 'SkiPassAvailableProducts',
                  component: SkiPassAvailableProducts,
                  meta: {
                    title: 'Ski pass: Available products',
                  },
                },
                {
                  path: 'pickup-places',
                  name: 'SkiPassPickupPlaces',
                  component: SkiRentalPickupPlaces,
                  meta: {
                    title: 'Ski pass: Pickup places',
                  },
                },
              ],
            },
            {
              path: 'school',
              name: 'SkiSchool',
              component: SkiSchool,
              props: true,
              redirect: { name: 'SkiSchoolOverview' },
              meta: {
                title: 'Ski school',
              },
              children: [
                {
                  path: 'overview',
                  name: 'SkiSchoolOverview',
                  component: SkiSchoolOverview,
                  meta: {
                    title: 'Ski school: Overview',
                  },
                },
                {
                  path: 'available-products',
                  name: 'SkiSchoolAvailableProducts',
                  component: SkiSchoolAvailableProducts,
                  meta: {
                    title: 'Ski school: Available products',
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: '/affiliates',
      name: 'Affiliates',
      component: Affiliates,
      meta: {
        title: 'Affiliates',
      },
    },
    {
      path: '/404',
      name: 'PageNotFound',
      component: PageNotFound,
    },
    {
      path: '*',
      redirect: {
        name: 'PageNotFound',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  document.title = to.meta && to.meta.title ? to.meta.title : 'Twenty Booking';
  if (!to.matched.some(record => record.meta.sessionFree)) {
    return session({ next });
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js